export interface ShippingBoxSpec {
  lengthInches: number;
  widthInches: number;
  heightInches: number;
  maxWeightLbs: number;
}

// Matches partysupplies.shipping.boxes.large in specs-ecom/config/packages/shipping.yaml
export const PARTY_SUPPLIES_LARGE_BOX: ShippingBoxSpec = {
  lengthInches: 20,
  widthInches: 20,
  heightInches: 20,
  maxWeightLbs: 25,
};
